exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pie-chart-legends {\n  display: flex;\n  justify-content: center;\n}\n\n.pie-chart-legend__color {\n  max-width: 11px;\n  max-height: 11px;\n  min-width: 11px;\n  min-height: 11px;\n  margin-right: 5px;\n  border-radius: 11px;\n}\n\n.pie-chart-legend__label {\n  padding-right: 5px;\n}\n\n.pie-chart-legend__label {\n  display: flex;\n  line-height: 15px;\n  align-items: center;\n  flex: 1;\n}\n\n.pie-chart-legend__percent-value,\n.pie-chart-legend__value {\n  display: flex;\n  margin: 0 10px;\n  justify-content: flex-end;\n  line-height: 10px;\n}\n\n.pie-chart-legend__percent-value {\n  color: gray;\n  font-size: 9px;\n}\n\n.pie-legend-horizontal {\n  min-width: 20px;\n  max-width: 80px;\n  overflow: hidden;\n  line-height: 10px;\n}\n\n.pie-legend-horizontal-value {\n  margin: 0;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/dashboard/widgets/pie-chart/legnend.scss
// module id = 1906
// module chunks = 0